import React from 'react';
import {PQLogo, FILogo, FISelector} from '../components.js'

class TopBar extends React.Component {

	/*constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		e.preventDefault();
		this.props.onClick();
	}*/

	render() {
		const logoSize = {
			width: "auto",
			height: "4vmin"
		};

		//REMOVED 06-03-2020 <FILogo class="NavBar-FILogo" size={logoSize} />
		const selector = (window._fiSponsor.sponsors.length > 1) ? (<FISelector />) : (<FILogo class="NavBar-FILogo" size={logoSize} />);
		return (

			<div className="App-NavBar">
				<div className="NavBar-Row">
				<div className="NavBar-LogoBox">
					<PQLogo size={logoSize} />
				</div>
				<div className="NavBar-FILogoBox">
					{selector}
				</div>
				<div className="Version-Box">
					{'v' + window.app.version}
				</div>
				</div>
			</div>

		);
	}
}

export default TopBar;